import { createContext } from 'react';

export const BreakpointsContext = createContext<string>('');
